<template>
  <span class="confetti-badge">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "ConfettiBadge",
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/variables/colors";

.confetti-badge {
  align-items: center;
  background: $badge-background-color;
  border-radius: 1.5em;
  cursor: default;
  display: inline-flex;
  padding-block: 0.4em;
  padding-inline: 0.8em;
  white-space: nowrap;
}
</style>
